export const NOTIFICATION_INTERVAL = 15000;
export const NOTIFICATION_MENU_KEY = ['menu', 'notification'];
export const NOTIFICATION_COUNT_KEY = ['menu', 'notification', 'count'];
